<template>
    <div class="container" v-if="career != undefined">
        <router-link class="btn back" :to="{ name: 'careers' }">
            <i class="ion-arrow-left-c"></i>
            <span v-if="$route.params.lang === 'hu'">vissza</span>
            <span v-else>all positions</span>
        </router-link>
        <main class="block-content">
            <h1>{{ career.title }}</h1>
            <div style="text-align:left; padding-bottom:20px; padding-top: 15px;">
			    <a v-if="$route.params.lang === 'hu'" :href="'mailto:' + career.mailto" class="btn">Jelentkezés</a>
                <a v-else :href="'mailto:' + career.mailto" class="btn">Application</a>
			</div>
            <ul class="position-details" v-if="career.employment || career.education">
                <li>{{ career.employment }}</li>
                <li>{{ career.education }}</li>
            </ul>
            <div v-html="career.description"></div>
        </main>
    </div>
</template>

<script>
export default {
    props: ['lang', 'slug'],
    beforeMount() {
        this.careers.fetch().then(resp => {     
            let careerArr = this.careers.filter(career => this.slug == career.slug);
            this.career = careerArr.length > 0 ? careerArr[0] : undefined;
        });
    },
    data() {
        return {
            careers: this.$collection({
                url: '/pa/careers',
            }),
            career: undefined,
        };
    },
};
</script>

<style lang="scss" scoped>
@import './../../sass/variables';
.back {
    margin-bottom: 20px;
}
.position-details {
    background-color: lighten(#000, 98%);
    display: inline-block;
    padding: 20px 40px;
}
</style>

<style>
.ql-align-center {
	display: block;
	margin-left: auto;
	margin-right: auto;
}

.ql-align-right {
    display: block;
    margin-left: auto;
}
</style>
